import { render, staticRenderFns } from "./ShowHoldGeneralBodyMeeting.vue?vue&type=template&id=ec263304&"
import script from "./ShowHoldGeneralBodyMeeting.vue?vue&type=script&lang=js&"
export * from "./ShowHoldGeneralBodyMeeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports